<template>
	<div class="groupBox" v-cloak>
		<ul>
			<li v-for="items in groupData">
				<!-- <img :src="items.img" alt="" :playUrl="items.url" @click="playV(items.url)"> -->
				<video controls="controls" preload='auto' class='my-video'  :src='items.video_url'  webkit-playsinline='true' playsinline='true'x-webkit-airplay='true' x5-video-player-type='h5' x5-video-player-fullscreen='true'x5-video-ignore-metadata='true' :poster="items.img_url"  width='100%' height='100%'><p> 不支持video</p> </video>
				<p>{{items.title3}}</p>
			</li>
		</ul>
    <div class="homeBotTxt">
      <p>Copyright ©2018 Scholar Education</p>
      <div>
        <router-link to="/en/LegalDeclaration" @click.native="changeHeadNavList">Legal Notices</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default{
	data(){
		return{
			groupData:groupData
		}
	},
	created(){
		this.axios.get(this.$root.baseUrl+'/wap/aboutUs/mien')
		.then(res=>{
			this.groupData = res.data;
			console.log(this.groupData)
		})
		.catch(e=>{
			console.log(e)
		})
	}
}
let groupData = [
	{
		'img':'../../../../static/img/groupImg1.png',
		'url':'',
		'txt':'十周年视频'
	},
	{
		'img':'../../../../static/img/groupImg2.png',
		'url':'',
		'txt':'十周年视频'
	}
]
</script>

<style scoped>
.groupBox{
    margin: 2.13rem 0 0;
	font-size: 1rem;
    padding: 0.6667rem 1.06667rem 0;
	box-sizing: border-box;
}
ul{
	font-size: 0;
}
ul p{
	font-size: 1rem;
    color: #333;
    margin: 0.86666rem 0.5333rem 0;
    display: inline-block;
}
li{
	margin-bottom: 1.53333rem;
    font-size: 0;
}
li video{
    border-radius: 4px!important;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/components/en/about/group.vue